import React, { useState } from "react";
import "./Scroll.css";
import { AiOutlineArrowUp } from "react-icons/ai";
const Scroll = () => {
  const [dis, setDisplay] = useState();
  window.onscroll = function () {
    scrollFunction();
  };
  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setDisplay("block");
      console.log(dis);
    } else {
      setDisplay("none");
      console.log(dis);
    }
  }
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  return (
    <div className="mybtn">
      <button style={{ display: dis }} onClick={() => topFunction()}>
        <AiOutlineArrowUp />
      </button>
    </div>
  );
};

export default Scroll;
